import React , { useEffect } from 'react';
import './App.css';
import { useStateContext } from './context/contextProvider';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Main from './pages/Main/Main';
import SideNavbar from './components/SideNavbar/SideNavbar';
import { dataCards } from './data/data';
import { Route, Routes } from 'react-router-dom';
import Companies from './components/Companies/Companies/Companies';
import PriceItem from './components/PriceItem/PriceItem';
import Club from './components/Club/Club/Club';
import Details from './components/Companies/Details/Details';
import NotFound from './components/Not-found-404/NotFound';
import 'react-loading-skeleton/dist/skeleton.css'
import DetalisClub from './components/Club/DetailsClub/DetailsClub';
import AOS from 'aos';
import "aos/dist/aos.css"
import About from './components/about/About';

function App() {

  const {printConsole , themeSettings} = useStateContext();

  useEffect( () => {
    AOS.init();
  })
  
  return (
    <div className="App" dir='rtl'>
      <Navbar />
      {
        themeSettings && 
        <SideNavbar />
      }
      <Routes>
        <Route path='/' element={<Main />}/>
        <Route path={dataCards[0].links} element={<PriceItem />} />
        <Route path={dataCards[1].links} element={<Companies />} />
        <Route path={`${dataCards[1].links}/details/:nameCompany`} element={<Details />} />  
        <Route path={dataCards[2].links} element={<Club />} />
        <Route path={`${dataCards[2].links}/details/:nameClub`} element={<DetalisClub />}  />
        <Route path='/about' element={<About />} />
        <Route path="*" exact element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
